<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <div class="wrapper-verify-account">
      <div (click)="logout()" class="back-btn">
        <img src="../assets/icons/icon-arrow-left.svg" alt="">
      </div>
      <div class="login-page">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login" style="margin: 20px 0px;">
          <h1>{{'NEW_TEXT.subscribe_to_company_plan' | translate}}</h1>
        </div>
        <tl-company-plan class="wrapper-company-plan-create"
          *ngIf="!isShowCompanyPayment"
          (clickToSubscribe)="isShowCompanyPayment = true"
        ></tl-company-plan>
        <tl-company-payment
          *ngIf="isShowCompanyPayment">
        </tl-company-payment>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
